// Shared typography for the top-level sidebar section headers (APPS, AGENTS).
// Sized smaller and tighter than shadcn's default SidebarGroupLabel because the
// section labels double as group dividers, not nav items.
export const SIDEBAR_SECTION_LABEL_CLASS = 'text-[10px] font-semibold uppercase tracking-widest';
